/* eslint-disable no-unused-vars */
import { nanoid } from 'nanoid'
import PromiseDialogEvent from '@/shared/constants/dialog/PromiseDialogEvent'

/**
 * @class
 * @public
 */
export default class PromiseDialogActionsDto {
  /**
   * @constructor
   */
  constructor({
    text = '',
    icon,
    attributes = {},
    event = PromiseDialogEvent.OK,
  } = {}) {
    /**
     * Unique key to facilitate the v-for loop. Generated by nanoid
     * @type {String}
     */
    this.key = nanoid()

    /**
     * Text displayed on the action button
     * @type {String}
     */
    this.text = text

    /**
     * Object that configure the action buttons on the dialog
     * @type {Array<Object>}
     */
    this.actions = icon

    /**
     * Object containing attributes to style the action button
     * @type {Object}
     * @see https://v2.vuetifyjs.com/en/api/v-btn/ for full list of attributes
     * @example
     *
     * ```
     * {
     *    id: 'confirm-btn',
     *    color: VuetifyColourClass.primary,
     *    text: true,
     *    title: 'Click here to accept the terms',
     *    'data-testid': 'promise-dialog--confirm-btn'
     * }
     * ```
     */
    this.attributes = attributes

    /**
     * Event returned when action button is clicked
     * @type {String}
     * @see {PromiseDialogEvent} for valid range of values
     */
    this.event = event
  }
}
